import { render, staticRenderFns } from "./ViewCustomer.vue?vue&type=template&id=7b11d496&scoped=true"
import script from "./ViewCustomer.vue?vue&type=script&lang=ts"
export * from "./ViewCustomer.vue?vue&type=script&lang=ts"
import style0 from "./ViewCustomer.vue?vue&type=style&index=0&id=7b11d496&prod&lang=scss&scoped=true"
import style1 from "./ViewCustomer.vue?vue&type=style&index=1&id=7b11d496&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b11d496",
  null
  
)

export default component.exports